import { useEffect, useMemo, useState } from "react";
import { Card, CardBody, Col, Nav, NavLink, Row } from "reactstrap";
import { Href } from "../../utils/Constant";
import ExpVerticalTabContent from "./ExpVerticalTabContent";
import { FaRupeeSign, FaRunning, FaPhotoVideo, FaFileAlt,FaMoneyBillAlt  } from "react-icons/fa";
import { useExpenseByEmployeeId, useExpenseDetails, useExpenseFWDetails, useExpenseLog, useExpenseNCADetails } from "./hooks/useExpense";


const ExpVerticalTabs = ({ data,openDates }: any) => {
  
  const [basicTab, setBasicTab] = useState<string>("1");

  const expData = [
  { id: "1", label: "Expense", notification: null,icon:<FaMoneyBillAlt />},
  { id: "2", label: "Field Work Breakup", notification: null, icon: <FaRunning /> },
  { id: "3", label: "Non Call Activity", notification: null, icon: <FaPhotoVideo /> },
  { id: "4", label: "Expense Log", notification: null, icon: <FaFileAlt /> },
];
  
  const validExpid = typeof data?.Expid === "number" && data?.Expid>0 ;
  
  const { data: apiData } = useExpenseDetails({
    id: data?.Expid,
    enabled:  validExpid ,
  });


   const isDateAllowed = useMemo(() => openDates?.includes(data?.date), [openDates, data?.date]);
  
    const shouldFetchFWData = useMemo(() => {
      return basicTab == "2" && !!data?.date && isDateAllowed;
    }, [basicTab, data.date, isDateAllowed]);

    const shouldFetchNCAData = useMemo(() => {
      return basicTab == "3" && !!data?.date && isDateAllowed;
    }, [basicTab, data.date, isDateAllowed]);



    const shouldFetchExpenseLogData = useMemo(() => {
      return basicTab == "4" && !!data?.date && isDateAllowed;
    }, [basicTab, data.date, isDateAllowed]);
  


    const { data: FWData } = useExpenseFWDetails({
      empId: data.employeeId,
      params: {date: shouldFetchFWData ? data?.date : undefined, },
      enabled: shouldFetchFWData,
    });

     const { data: NCAData } = useExpenseNCADetails({
      empId: data.employeeId,
      params: {
        date: shouldFetchNCAData ? data?.date : undefined,
      },
      enabled: shouldFetchNCAData,
    });
     

    const {data: expenseLogData} = useExpenseLog({
      id: data?.Expid,
      params: {
        date:shouldFetchExpenseLogData? data?.date : undefined,
      },
      enabled: shouldFetchExpenseLogData,
    });

  const getColorsNoti = (item: any) => {
    switch (item.label) {
      case "Expense": return "#43B9B2";
      case "Field Work Breakup": return "#2F8DD3";
      case "Non Call Activity": return "#0EB21B";
      default: return "transparent";
    }
  };


  return (
    <Col>
      <Card>
        <CardBody>
          <Row>
            <Col md="4" xs="12">
              <Nav pills className="flex-column nav-tertiary">
                {expData.map((item) => (
                  <NavLink
                    key={item.id}
                    className={`d-flex justify-content-between align-items-center ${basicTab === item.id ? "active" : ""}`}
                    onClick={() => setBasicTab(item.id)}
                    style={{
                      padding: "10px 15px",
                      backgroundColor: basicTab === item.id ? "#ECF8F7" : "transparent",
                      color: basicTab === item.id ? "#43B9B2" : "grey",
                      borderRadius: "5px",
                      cursor: "pointer",
                  }}
                  >
                    <div className="d-flex align-items-center gap-2">
                      <span style={{marginTop:item.id =='1'?'-5px':'0px',  fontSize: "16px", color: basicTab === item.id ? '#43B9B2' : 'grey' }}>{item.icon}</span>
                      <span style={{ color: basicTab === item.id ? '#43B9B2' : 'grey' }}>{item.label}</span>
                    </div>
                    {item.notification !== null && (
                      <span
                        style={{
                          backgroundColor: getColorsNoti(item),
                          color: "white",
                          borderRadius: "12px",
                          padding: "3px 9px",
                          fontSize: "12px",
                          fontWeight: "bold",
                        }}
                      >
                        {item.notification}
                      </span>
                    )}
                  </NavLink>
                ))}
              </Nav>
            </Col>

            <ExpVerticalTabContent basicTab={basicTab} tabData={apiData?.data||[]} FwData={FWData?.data||[]} NCAData={NCAData?.data||[]} expenseLog={expenseLogData?.data||[]}/>
          </Row>
        </CardBody>
      </Card>
    </Col>
  );
};

export default ExpVerticalTabs;
